// extracted by mini-css-extract-plugin
export var active = "_ld-2";
export var recordingDot = "_ld-1";
export var recordingIndicator = "_ld-0";